export { default } from "./WorkBreakdownV2Mspa";
